// extracted by mini-css-extract-plugin
module.exports = {"item":"select-item_item__0ldVP","text":"select-item_text__abJOl","indicator":"select-item_indicator__4xe5O"};